<template>
  <div>
    <el-upload class="avatar-uploader cus-avatar-uploader" :action="action"  :show-file-list="false" :on-success="uploadSuccess" :on-error="uploadError" :before-upload="beforeUpload">
    </el-upload>
    <quill-editor
    class="editor"
    ref="myQuillEditor"
    v-model="content"
    :options="editorOption"
    @change="onEditorChange($event)"
    :style="{height:height+'px',width:width+'px'}"
  ></quill-editor>
  </div>
   
  </template>
  
  <script>
  const toolbar = [
    ["bold", "italic", "underline", "strike"], // 加粗 斜体 下划线 删除线
    ["blockquote", "code-block"], // 引用  代码块
    [{ header: 1 }, { header: 2 }], // 1、2 级标题
    [{ list: "ordered" }, { list: "bullet" }], // 有序、无序列表
    //   [{ script: "sub" }, { script: "super" }], // 上标/下标
    //   [{ indent: "-1" }, { indent: "+1" }], // 缩进
    // [{'direction': 'rtl'}],                         // 文本方向
    [{ size: ["small", false, "large", "huge"] }], // 字体大小
    [{ header: [1, 2, 3, 4, 5, 6, false] }], // 标题
    [{ color: [] }, { background: [] }], // 字体颜色、字体背景颜色
    [{ font: [] }], // 字体种类
    [{ align: [] }], // 对齐方式
    ["clean"], // 清除文本格式
    ["link", "image", "video"] // 链接、图片、视频
  ]; //工具菜单栏配置
  import { ImageDrop } from 'quill-image-drop-module'
import ImageResize from 'quill-image-resize-module'
import Quill from 'quill'
Quill.register('modules/imageDrop', ImageDrop)
Quill.register('modules/imageResize', ImageResize)
  export default {
    props:{
      width:{type:[Number,String],default:'80%'},
      height:{type:[Number,String],default:400},
      des:{type:String,default:null}
    },
    watch: {
      des(){
        this.content = this.des
      },
    },
    data() {
      return {
        content: null, //内容
        action:localStorage.getItem("upload"),
        editorOption: {
          modules: {
            // toolbar,
            // handlers: {
            //   image: function (value) {
            //     if (value) {
            //       // 触发input框选择图片文件
            //       document.querySelector(".cus-avatar-uploader input").click();
            //     } else {
            //       // this.quill.format("image", false);
            //     }
            //   },
            // },
            toolbar: {
                    container: toolbar,  // 工具栏
                    handlers: {
                        'image': function (value) {
                            if (value) {
                                // 调用iview图片上传
                                document.querySelector(".cus-avatar-uploader input").click();
                            } else {
                                this.quill.format('image', false);
                            }
                        }
                    }
                },
            history: {
              delay: 1000,
              maxStack: 50,
              userOnly: false
            },
            imageDrop: true,
            imageResize: {
              displayStyles: {
                backgroundColor: 'black',
                border: 'none',
                color: 'white'
              },
              modules: [ 'Resize', 'DisplaySize', 'Toolbar' ]
            }
        },
        placeholder: '输入内容........'
          },
          placeholder: "", //提示
          readyOnly: false, //是否只读
          theme: "snow", //主题 snow/bubble
          syntax: true //语法检测
        }
      
    },
    methods: {
      // 值发生变化
      onEditorChange(editor) {
        this.content = editor.html;
        this.$emit("content", editor.html);
      },
       // 富文本图片上传前
    beforeUpload () {
      // 显示loading动画
      // this.quillUpdateImg = true;
    },
    handletoclick(){
      document.querySelector(".cus-avatar-uploader input").click();
    },
    
    // 图片上传成功方法,res为图片服务器返回的数据 注意数据返回结构
    uploadSuccess (res) {  // res为图片服务器返回的数据 注意数据返回结构
      // 获取富文本组件实例
      console.log(res)
      let quill = this.$refs.myQuillEditor.quill;
      // 如果上传成功
      if (res.status == 2000) {
        // 获取光标所在位置
        let length = quill.getSelection().index;
        // 插入图片  res.data为服务器返回的图片地址
        quill.insertEmbed(length, "image", res.data);
        // 调整光标到最后
        quill.setSelection(length + 1);
      } else {
        this.$message.error("图片插入失败");
      }
      // loading动画消失
      this.quillUpdateImg = false;
    },
    // 富文本图片上传失败
    uploadError () {
      // loading动画消失
      this.quillUpdateImg = false;
      this.$message.error("图片上传失败");
    }
    },
    created() {
      // console.log('des',this.des)
      // if(this.des){
      //   this.content = this.des
      // }
    },
  };
  </script>
  
  <style>
  .editor {
    line-height: normal !important;
    height: 800px;
    margin-bottom: 30px;
  }
  .ql-snow .ql-tooltip[data-mode="link"]::before {
    content: "请输入链接地址:";
  }
  .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
    border-right: 0px;
    content: "保存";
    padding-right: 0px;
  }
  
  .ql-snow .ql-tooltip[data-mode="video"]::before {
    content: "请输入视频地址:";
  }
  
  .ql-snow .ql-picker.ql-size .ql-picker-label::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item::before {
    content: "14px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
    content: "10px";
  }
  
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
    content: "18px";
  }
  .ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
  .ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
    content: "32px";
  }
  
  .ql-snow .ql-picker.ql-header .ql-picker-label::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item::before {
    content: "文本";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
    content: "标题1";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
    content: "标题2";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
    content: "标题3";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
    content: "标题4";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
    content: "标题5";
  }
  .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
  .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
    content: "标题6";
  }
  
  .ql-snow .ql-picker.ql-font .ql-picker-label::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item::before {
    content: "标准字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
    content: "衬线字体";
  }
  .ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
  .ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
    content: "等宽字体";
  }
  </style>